import { render, staticRenderFns } from "./ChangeMail.vue?vue&type=template&id=5041c68e&"
import script from "./ChangeMail.vue?vue&type=script&lang=js&"
export * from "./ChangeMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports